
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

export interface Transaction {
  id: string;
  date: string;
  description: string;
  amount: string;
  type: "deposit" | "withdrawal";
}

interface WalletActivityProps {
  transactions: Transaction[];
}

const WalletActivity = ({ transactions }: WalletActivityProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {transactions.length === 0 ? (
          <p className="text-center text-gray-400 dark:text-muted-foreground">
            No recent transactions to show
          </p>
        ) : (
          <div className="space-y-4">
            {transactions.map((transaction) => (
              <div
                key={transaction.id}
                className="flex items-center justify-between py-3 border-b last:border-b-0"
              >
                <div className="flex items-center">
                  <div className={`h-8 w-8 mr-3 rounded-full flex items-center justify-center ${
                    transaction.type === "deposit"
                      ? "bg-green-100 text-green-600"
                      : "bg-orange-100 text-orange-600"
                  }`}>
                    {transaction.type === "deposit" ? (
                      <ArrowDownIcon size={16} />
                    ) : (
                      <ArrowUpIcon size={16} />
                    )}
                  </div>
                  <div>
                    <p className="font-medium">{transaction.description}</p>
                    <p className="text-sm text-gray-500 dark:text-muted-foreground">
                      {transaction.date}
                    </p>
                  </div>
                </div>
                <div
                  className={`font-semibold ${
                    transaction.type === "deposit" ? "text-green-600" : ""
                  }`}
                >
                  {transaction.type === "deposit" ? "+" : "-"}
                  {transaction.amount}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default WalletActivity;
